export default __webpack_public_path__ + "static/media/researchgatlogo.068d218d.png";